<template>
    <div class="Finance">
        <div class="main">
            <div class="left">
                <div class="custom-tree-container">
                    <el-tree
                        :data="Treedata"
                        default-expand-all
                        :props="defaultProps"
                        node-key="id"
                        @node-click="handleNodeClick"
                    ></el-tree>
                </div>
            </div>
            <div class="right">
                <div class="title">
                    <h1 style="text-align:center;">{{this.dataName}}</h1>
                    <div class="head">
                        <div style="line-height: 100px;" v-if="this.type === 1">
                            <div style="font-size:20px;">描述：{{this.dataDescribe}}</div>
                        </div>

                        <div v-if="this.type === 4||this.type === 3" style="line-height: 50px;">
                            <div style="font-size:20px;">描述：{{this.dataDescribe}}</div>
                            <div>
                                <span>推广提成：{{this.mainData.promotionCommission}} %（平台费提成）</span>
                            </div>
                        </div>
                        <div style="display:flex;align-items: center;">
                            <el-button type="primary" @click="EditClick" v-if="this.type === 4">编辑</el-button>
                            <el-button type="success" v-if="this.type === 3" @click="Addalert">添加员工</el-button>
                            <el-button type="danger" @click="Delete" v-if="this.type == 4">删除</el-button>
                        </div>
                    </div>

                    <div class="body" v-if="this.type === 4">
                        <div class="body-title">
                            <span>角色分配：</span>
                            <span class="associated" @click="associated">关联用户</span>
                        </div>
                        <div class="table">
                            <table class="tableData" cellpadding="0" cellspacing="0">
                                <tr>
                                    <th style="border-right:1px solid #ebeef5;width:33%;">姓名</th>
                                    <th style="border-right:1px solid #ebeef5;width:33%;">账号</th>
                                    <th style="width:33%;">操作</th>
                                </tr>
                                <tr>
                                    <td
                                        style="border-right:1px solid #ebeef5;width:33%;"
                                    >{{this.roleUserName}}</td>
                                    <td
                                        style="border-right:1px solid #ebeef5;width:33%;"
                                    >{{this.telephone}}</td>
                                    <td style="width:33%;">
                                        <el-button type="danger" @click="remove">移除</el-button>
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </div>

                    <!-- <div class="body" v-if="this.type === 4">
                        <div class="body-title">
                            产品分享权限分配：
                            <el-button type="primary" size="mini" @click="share">保存</el-button>
                        </div>
                        <div class="table">
                            <div>
                                <el-checkbox v-model="checked">产品分享</el-checkbox>
                            </div>
                            <div style="margin-top: 20px;">
                                <el-checkbox v-model="checked1">产品分享特殊权限</el-checkbox>
                            </div>
                        </div>
                    </div> -->

                    <div class="body" v-if="this.type === 4||this.type === 3">
                        <div class="body-title">
                            <span>邀请公司</span>
                        </div>
                        <div class="body-title1">
                            <div>
                                <span>已分配公司：</span>
                                <el-button size="mini" type="primary" v-if="this.type === 4" v-show="isShow1" @click="isShow=true,isShow1=false">编辑</el-button>
                                <el-button size="mini" type="primary" style="margin-left:0px;" v-show="isShow" @click="isShow=false,isShow1=true">保存</el-button>
                                <el-button size="mini" style="margin-left:10px;" v-show="isShow" @click="isShow=false,isShow1=true">取消</el-button>
                            </div>
                            <div style="margin-top: 20px;"></div>
                            <div class="Distribution" v-for="item in this.distribution">
                                <span class="DistributionSpan">{{item.companyFullName}}</span>
                                <el-button style="margin-left:10px;" type="danger" icon="el-icon-delete" v-show="isShow" @click="unbundling(item)"></el-button>
                            </div>
                        </div>
                        <div class="table" v-if="this.type === 4">
                            <div class="body-title">搜索公司</div>
                            <div class="body-title" style="border-bottom:0;">
                                <el-input style="width:200px;" v-model="companyFullName"></el-input>
                                <el-button type="primary" style="margin-left:20px;" @click="search">搜索</el-button>
                                <el-button type="primary" @click="reset">重置</el-button>
                            </div>
                            <div style="margin-top:20px;">
                                <el-table :data="companyList" border style="width: 100%">
                                    <el-table-column prop="companyFullName" label="子公司全称" align="center"></el-table-column>
                                    <el-table-column prop="chineseShortName" label="子公司简称" align="center"></el-table-column>
                                    <el-table-column label="boss关联用户姓名" align="center">
                                        <template slot-scope="scope">
                                            {{scope.row.boss.userName}}
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="boss关联用户账号" align="center">
                                        <template slot-scope="scope">
                                            {{scope.row.boss.telephone}}
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="业务经理" align="center">
                                        <template slot-scope="scope">
                                            {{scope.row.promotionCommissionRoleUserName}}
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="操作" align="center">
                                        <template slot-scope="scope">
                                            <el-button v-if="scope.row.promotionCommissionRoleUserName  === ''" type="primary" @click="Adddistribution(scope.row)">添加</el-button>
                                            <el-button v-if="scope.row.promotionCommissionRoleUserName !=''" type="danger" disabled>不可操作</el-button>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 添加 -->
        <el-dialog :title="this.AddName" :visible.sync="Add" width="35%">
            <el-form ref="form" label-width="90px">
                <el-form-item label="名称">
                    <el-input v-model="name"></el-input>
                </el-form-item>
                <el-form-item label="描述">
                    <el-input v-model="describe"></el-input>
                </el-form-item>
                <el-form-item label="推广提成">
                    <el-input-number size="small" v-model="promotionCommission" :min="0" :max="100" controls-position="right" style="width:200px;"></el-input-number> %
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="Add = false">取消</el-button>
                <el-button type="primary" @click="save">保存</el-button>
            </div>
        </el-dialog>
        <!-- 编辑 -->
        <el-dialog :title="this.EditName" :visible.sync="Edit" width="30%">
            <el-form ref="form" label-width="90px">
                <el-form-item label="名称">
                    <el-input v-model="name1"></el-input>
                </el-form-item>
                <el-form-item label="描述">
                    <el-input v-model="describe1"></el-input>
                </el-form-item>
                <el-form-item label="推广提成" v-if="this.type === 4">
                    <el-input-number size="small" v-model="promotionCommission1" :min="0" :max="100" controls-position="right" style="width:200px;"></el-input-number> %
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="Edit = false">取消</el-button>
                <el-button type="primary" @click="EditSave">保存</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { ajaxPost, Baseurl } from "../../../../api/api/api";
export default {
    name: "department",
    components: {},
    data() {
        return {
            str: "",
            department: "",
            Treedata: [],
            mainData: "",
            roleUserName: "",
            telephone: "",

            name: "",
            name1: "",
            describe: "",
            describe1: "",
            promotionCommission:"",
            promotionCommission1:"",

            dataName: "",
            dataDescribe: "",
            AddName: "",
            EditName: "",
            checked: "",
            checked1: "",
            shopdata: [],
            type: "",
            disable: "",
            Add: false,
            Edit: false,
            defaultProps: {
                children: "child",
                label: "name"
            },
            isShow:false,
            isShow1:true,
            accountManagerId:"",
            companyList:[],
            companyFullName:"",
            distribution:[]
        };
    },
    created() {
        this.str = JSON.parse(localStorage.getItem("role"));
        this.informationAll();
    },
    methods: {
        handleNodeClick(data) {
              this.dataName = data.name
              this.dataDescribe = data.describe
              this.type = data.type
              console.log(data)
              var obj = {company_id:this.str.company_id,rid:data.rid,system:data.system,dgrId:data.dgrId,departmentId:data.departmentId}
              ajaxPost(Baseurl + "roleController/findRoleByRid",obj).then(res => {
                this.mainData = res.data.data
                this.roleUserName = this.mainData.roleUserName
                this.telephone = this.mainData.telephone
                this.shopdata = res.data.data.roleSeller
                this.accountManagerId = res.data.data.rid
                this.checked = res.data.data.share
                this.checked1 = res.data.data.shareSpecial

                this.distribution = res.data.data.promotionCommissionAssignedCompanyList
            });
        },
        informationAll() {
            var obj = {
                rid: this.str.rid,
                gid:this.str.gid,
                system:this.str.system,
                superDepartmentName: "商务部"
            };
            ajaxPost(Baseurl + "roleController/selectNextByRole",obj).then(res => {
                this.dataName = res.data.data.Business_Group.name;
                this.dataDescribe = res.data.data.Business_Group.describe;
                this.type = res.data.data.Business_Group.type;

                this.mainData = res.data.data.Business_Group;
                this.roleUserName = this.mainData.roleUserName;
                this.telephone = this.mainData.telephone;
                this.accountManagerId = res.data.data.Business_Group.rid
                this.Treedata = [res.data.data.Business_Group];
                this.shopdata = res.data.data.Business_Group.departmentSeller;
            });
        },
        associated() {
            this.$prompt("账号", "关联用户", {
                confirmButtonText: "确定",
                cancelButtonText: "取消"
            })
                .then(({ value }) => {
                    if (value === "") {
                        this.$message.error("账号不能为空");
                    } else {
                        var obj = {
                            rid: this.mainData.rid,
                            telephone: value
                        };
                        ajaxPost(
                            Baseurl + "roleController/relationUser",
                            obj
                        ).then(res => {
                            // console.log(res.data)
                            if (res.data.code === 200) {
                                this.$message({
                                    type: "success",
                                    message: "关联用户成功"
                                });
                                this.roleUserName = res.data.data.roleUserName;
                                this.telephone = res.data.data.telephone;
                            } else {
                                this.$message.error(res.data.data);
                            }
                        });
                    }
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "取消输入"
                    });
                });
        },
        remove() {
            this.$confirm(
                "是否确定移除该关联用户",
                "提示",
                {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                }
            )
                .then(() => {
                    var obj = {
                        rid: this.mainData.rid,
                        system: this.mainData.system
                    };
                    console.log(obj);
                    ajaxPost(
                        Baseurl + "roleController/cancelRelationUser",
                        obj
                    ).then(res => {
                        if (res.data.code === 200) {
                            this.$message({
                                type: "success",
                                message: "移除用户成功"
                            });
                            this.roleUserName = res.data.data.roleUserName;
                            this.telephone = res.data.data.telephone;
                        } else {
                            this.$message.error(res.data.data);
                        }
                    });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消移除"
                    });
                });
        },
        Addalert() {
            this.Add = true;
            this.AddName = "添加员工";
        },
        handleAvatarSuccess(res, file) {
            this.imageUrl = res.data;
        },
        handleAvatarSuccess1(res, file) {
            this.imageUrl1 = res.data;
        },
        save() {
            this.Add = false;
            var obj = {
                company_id: this.str.company_id,
                dgrId: this.mainData.dgrId,
                name: this.name,
                describe: this.describe,
                system: this.mainData.system,
                departmentName: "商务部",
                promotionCommission:this.promotionCommission
            };
            ajaxPost(Baseurl + "userControllers/insertDgr", obj).then(res => {
                console.log(res.data);
                if (res.data.code === 200) {
                    this.$message({
                        type: "success",
                        message: "添加成功"
                    });
                    this.Treedata = [res.data.data.Business_Group];
                } else {
                    this.$message.error(res.data.data);
                }
                this.name = "";
                this.describe = "";
                this.promotionCommission = ""
            });
        },
        EditClick() {
            this.Edit = true;
            if (this.type === 3) {
                this.EditName = "编辑组";
                this.disable = false;
                this.name1 = this.dataName;
                this.describe1 = this.dataDescribe;
                this.promotionCommission1 = this.mainData.promotionCommission;
            }else if (this.type === 4) {
                this.EditName = "编辑员工";
                this.disable = false;
                this.name1 = this.dataName;
                this.describe1 = this.dataDescribe;
                this.promotionCommission1 = this.mainData.promotionCommission;
            }
        },
        EditSave() {
            var obj = {
                rid: this.mainData.rid,
                did: this.mainData.did,
                roleName: this.name1,
                remarks: this.describe1,
                promotionCommission:this.promotionCommission1,
                system:this.mainData.system
            };
            console.log(obj);
            ajaxPost(Baseurl + "roleController/updateCustomer", obj).then(res => {
                if (res.data.code === 200) {
                    this.$message({
                        type: "success",
                        message: "修改成功"
                    });
                    this.Treedata = [res.data.data.Business_Group];
                    this.dataName = res.data.data.role.roleName
                    this.dataDescribe = res.data.data.role.remarks;
                    this.mainData = res.data.data.role
                } else {
                    this.$message.error(res.data.data);
                }
            });

            this.Edit = false;
        },
        Delete() {
            this.$confirm(
                "该操作将删除当前角色（组/分部门）的全部数据，是否继续",
                "提示",
                {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                }
            )
                .then(() => {
                    var obj = {
                        dgrId: this.mainData.dgrId,
                        system: this.mainData.system
                    };
                    ajaxPost(Baseurl + "userControllers/deleteDgr", obj).then(
                        res => {  
                            if (res.data.code === 200) {
                                this.$message({
                                    type: "success",
                                    message: "删除成功"
                                });
                                this.informationAll();
                            } else {
                                this.$message.error(res.data.data);
                            }
                        }
                    );
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消删除"
                    });
                });
        },
        // share() {
        //     var obj = {
        //         rid: this.mainData.rid,
        //         share: this.checked,
        //         shareSpecial: this.checked1
        //     };
        //     ajaxPost(
        //         Baseurl + "roleController/allotProductSharingSpecial",
        //         obj
        //     ).then(res => {
        //         if (res.data.code === 200) {
        //             console.log(res.data);
        //             this.$message({
        //                 type: "success",
        //                 message: "保存成功"
        //             });
        //         } else {
        //             this.$message.error(res.data.data);
        //         }
        //     });
        // },
        Adddistribution(value){
            var obj = {
                promoterId:this.mainData.rid,
                company_id: value.id
            };
            ajaxPost(Baseurl + "roleController/allotPromotionCommissionForCompany", obj).then(res => {
                console.log(res.data)
                if(res.data.code == 200){
                    this.$message({
                        message: '绑定成功',
                        type: 'success'
                    });
                    this.distribution = res.data.data
                    this.search()
                }else{
                    this.$message.error(res.data.data);
                }
            });
        },
        search(){
            var obj = {
                companyFullName:this.companyFullName,
                pid:this.str.company_id,
                signRid:this.str.rid
            };
            ajaxPost(Baseurl + "companyController/selectCompanyByCompanyName", obj).then(res => {
                // console.log(res.data)
                if(res.data.code == 200){
                    this.companyList = res.data.data
                }else if(res.data.code == 500){
                    this.$message.error(res.data.data);
                }
            });
        },
        reset(){
            this.companyFullName = ""
            this.companyList = []
        },
        unbundling(item){
                console.log(item)
                var obj = {
                    company_id:item.id
                }
                ajaxPost(Baseurl + "roleController/untiePromotionCommissionFromCompany", obj).then(res => {
                    if(res.data.code == 200){
                        this.$message({
                            message: '解绑成功',
                            type: 'success'
                        });
                        this.search()
                        this.distribution = res.data.data
                    }else{
                        this.$message.error(res.data.data);
                    }
                });
            
        }
    }   
};
</script>

<style lang="scss" scoped>
/deep/{
    .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
}
.left {
    padding: 30px;
    width: 20%;
    float: left;
}
.custom-tree-container {
    margin-top: 30px;
}
.right {
    width: 80%;
    padding: 30px;
}
.main {
    width: 100%;
    display: flex;
    justify-content: space-between;
}
.head {
    display: flex;
    justify-content: space-between;
    // height: 100px;
    border-bottom: 1px solid #e4e7ed;
}
.body {
    border: 1px solid #e4e7ed;
    padding: 15px;
    margin-top: 30px;
}
.body-title {
    width: 100%;
    height: 25px;
    padding: 10px;
    border-bottom: 1px solid #e4e7ed;
}
.body-title1 {
    width: 100%;
    padding: 10px;
    border-bottom: 1px solid #e4e7ed;
}
.table {
    margin-top: 30px;
}
.table table {
    width: 100%;
    height: 100px;
    text-align: center;
    border: 1px solid #ebeef5;
}
.table td {
    color: #606266;
}
.table th {
    border-bottom: 1px solid #ebeef5;
    color: #909399;
}
.associated {
    cursor: pointer;
    color: #409eff;
}
.el-form-item {
    margin-bottom: 0px;
}
.DistributionSpan{
    display: inline-block;
    height: 40px;
    line-height: 40px;
    text-align: center;
}
</style>